var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", {
        staticClass: "cursor-pointer",
        on: {
          click: function ($event) {
            return _vm.openWelcomePopup()
          },
        },
      }),
      _c("welcome-popup"),
      _c("render-popup", {
        attrs: {
          roleId: _vm.roleId,
          displayRep: _vm.displayRep,
          playNextTour: _vm.playNextTour,
          previousTour: _vm.previousTour,
          currentTour: _vm.currentTour,
          tourObjectLength: _vm.tourObject.length,
          tourIndex: _vm.tourIndex,
        },
      }),
      _c("account-settings-popup", {
        attrs: {
          previousTour: _vm.previousTour,
          tourlength: _vm.tourObject.length,
        },
      }),
      _c("success-popup"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }